import React, { useState } from 'react';
import {
    Container,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText,
    Button,
} from 'react-bootstrap';
import '../styles/MobileNavbar.css'
import ContactButton from "./ContactButton";
import Logo from '../assets/logo/bba_log.svg'
import useWindowDimensions from "./useWindowDimensions";

const MobileNavi = (props) => {
    const { height, width } = useWindowDimensions();

    return (
        <div className="Mobile-header" style={{height: height * 15 /100}}>
            <div>
                <a href="/">
                    <img src={Logo} className="Mobile-logo" style={{width: width / 3 , height:height *10/100 , marginLeft:width/3 + 10}}/>
                </a>

                    <div className="Logos" style={{ marginTop:1}}>
                        <a href="https://www.instagram.com/balikesirbakiciajansi?igsh=MTN1NjJ2eDl4ZnFtZQ==" >
                            <i className="fab fa-instagram"/>
                        </a>
                        <a href="https://www.facebook.com/share/16P6CmnPhG/"
                        style={{marginLeft: 15}}>
                            <i className="fab fa-facebook-f"/>
                        </a>
                        <a href="https://www.linkedin.com/company/balikesirkbdanismanlik">
                            <i className="fab fa-linkedin-in" style={{marginLeft:15}} />
                        </a>
                    </div>
            </div>

        </div>
    );
}

export default MobileNavi;
